import { AxleButton } from '@/components/buttons/AxleButton';
import { Edit } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { FC } from 'react';

export const patientFieldStyles = {
    height: '48px',
    borderRadius: '4px',
};

type EditCancelButtonsProps = {
    isEditing: boolean;
    onCancel(): void;
    onSubmit(): void;
    onEdit(): void;
    disableSave?: boolean;
};

export const EditCancelButtons: FC<EditCancelButtonsProps> = (props) => {
    const { isEditing, onCancel, onSubmit, onEdit, disableSave } = props;

    if (isEditing) {
        return (
            <Box display='flex' gap={2} marginBottom={1} alignItems='center'>
                <AxleButton size='small' variant='outlined' onClick={onCancel}>
                    Cancel
                </AxleButton>
                <AxleButton size='small' onClick={onSubmit} disabled={disableSave}>
                    Save
                </AxleButton>
            </Box>
        );
    }

    return (
        <Button
            variant='contained'
            size='small'
            startIcon={<Edit />}
            onClick={onEdit}
            sx={{
                textTransform: 'none',
                backgroundColor: 'grey.200',
                color: 'text.secondary',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: 'grey.300',
                    boxShadow: 'none',
                },
            }}
        >
            Edit
        </Button>
    );
};
